export const ROOT_ELEMENT_ID = 'synergy-nform-root';
export const ROOT_ELEMENT_CLASS_NAME = 'synergy-nform-root';

export const LOADING_ELEMENT_ID = 'synergy-nform-loading';

export const TRACKING_SCRIPT_ELEMENT_ID = 'synergy-tm-script';
